<div>
  <div class="table-container">
    <table id="syncHistoryTable" mat-table [dataSource]="syncListResult.syncs" class="isc-table">

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell [id]="'syncIcon_'+rowNum" mat-cell *matCellDef="let sync;let rowNum = index">
          @if (sync.syncType === syncTypeValues[0]) {
            <span
            class="crm-industrial-font icon-cloud-offline syncIcons"></span>
          }
          @if (sync.syncType === syncTypeValues[1]) {
            <span class="crm-industrial-font icon-cloud syncIcons"></span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th id="syncTypeHeader" mat-header-cell *matHeaderCellDef>{{appStrings.syncHistory_type}}</th>
        <td [id]="'syncType_'+rowNum" mat-cell *matCellDef="let sync;let rowNum = index">
          {{sync.syncType}}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th id="syncStatusHeader" mat-header-cell *matHeaderCellDef>{{appStrings.syncHistory_status}}</th>
        <td [id]="'syncStatus_'+rowNum" mat-cell *matCellDef="let sync;let rowNum = index"
          [ngClass]="{'yellow': sync.syncStatus === syncStatusValues[0], 'green': sync.syncStatus === syncStatusValues[1], 'red': sync.syncStatus === syncStatusValues[2] }">
          {{sync.syncStatus}}
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th id="startDateHeader" mat-header-cell *matHeaderCellDef>{{appStrings.syncHistory_startDate}}</th>
        <td [id]="'startDate_'+rowNum" mat-cell *matCellDef="let sync;let rowNum = index">
          {{sync.startDate | date:dateTimeFormat}}
        </td>
      </ng-container>

      <ng-container matColumnDef="syncDate">
        <th id="syncDateHeader" mat-header-cell *matHeaderCellDef>{{appStrings.syncHistory_syncDate}}</th>
        <td [id]="'syncDate_'+rowNum" mat-cell *matCellDef="let sync;let rowNum = index">
          {{sync.syncDate | date:dateTimeFormat}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div id="paginatorContainer" class="flex-container">
    @if (syncListResult.countSyncs && syncListResult.syncs) {
      <mat-paginator id="errorsListPaginator" [length]="syncListResult.countSyncs" [pageSize]="pageSize"
        [hidePageSize]="true" [showFirstLastButtons]="true" (page)="loadPage($event)" [pageIndex]="currentPage">
      </mat-paginator>
    }
  </div>
</div>